import { customerAddressFormSchema } from './create-form.js';
import { createCustomerAddressInputSchema } from './create-input.js';
export function toCreateCustomerAddressInput(values, customerName) {
    const parsed = customerAddressFormSchema.parse(values);
    return createCustomerAddressInputSchema.parse({
        name: customerName,
        addressName: parsed.addressName,
        typeId: Number(parsed.typeId),
        address: parsed.address,
        city: parsed.city ?? null,
        stateId: parsed.stateId ?? null,
        countryId: parsed.countryId ?? null,
        zip: parsed.zip ?? null,
        ...(parsed.defaultFlag === true ? { defaultFlag: true } : {}),
    });
}
//# sourceMappingURL=create-mapper.js.map